import '@aws-amplify/ui-react/styles.css';
import AppMenu from './AppMenu';
import { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { Navigate, Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import apimisempresas from './api/apiweb-misempresas.js';
import Search from './views/buscadordocs/Search.js'; 
import apidevice from './api/apiweb-device.js';
import CierreCaja from './views/cierrecaja/CierreCaja.js'
import Conciliation from './views/conciliation/Conciliation.js';
import EstadoCajeros from './views/estado_cajeros/EstadoCajeros';
import ResumenDiarioBoletas from './views/resumendiarioboletas/Form.js';
import ResumenMensualBoletas from './views/resumenmensualboletas/Form.js';
import PosUserConfig from './views/posuserconfig/PosUserConfig.js';
import Resumensinc from './views/resumen_sincronizacion_scharfstein/resumensinc.js'
import useUserPermissions from './hooks/useUserPermissions.js';
import Factura from './views/factura/Factura.js';
import Skualo from './views/skualo/Skualo.js';
import ReceptorFactura from './views/receptorFactura/receptorFactura.js';
import EmisorMasivo from './views/emisorMasivo/EmisorMasivo.js';



function App({ signOut, user }) {
  const [collapsed, setCollapsed] = useState(true);
  const [toggled, setToggled] = useState(false);
  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  const [empresas, setEmpresas] = useState(false);
  const [devices, setDevices] = useState(false);
  const permissions = useUserPermissions();

  const hasPermission = (permissionName) => {
    return permissions.some(permission => permission.permission_name === permissionName);
  };


  useEffect(() => {
    if(!empresas) {
      apimisempresas.getData({}).then(
          (data) => {
              setEmpresas(data.data.records);
          }
      ).catch(
          (error)=>{setEmpresas(true);}
      )
    }
    if(!devices) {
      // console.log(devices)
      apidevice.getAllDevices({}).then(
          (data) => {
              setDevices(data.data.records);
              // console.log(data.data.records);
          }
      ).catch(
          (error)=>{setDevices(true);}
      )
    }

   
  }
  , [empresas, devices]);
  


  const handleCollapsedChange = (checked) => {
    setCollapsed(checked);
  };

  return (
    <div className={`app ${toggled ? 'toggled' : ''}`}>
      <BrowserRouter>
        <AppMenu
          collapsed={collapsed}
          toggled={toggled}
          handleToggleSidebar={handleToggleSidebar}
          handleCollapsedChange={handleCollapsedChange}
          empresas={empresas}
        />
    <main>
      <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
        <FaBars />
      </div>
      <header>
        {empresas && empresas?.map((e) => e.name)}
      </header>
      <div className="main-scroll">
      <Routes>
        <Route path="/" element={<Navigate to="/search" replace />} />
        <Route path="/search" element={<Search devices={devices} empresas={empresas} facturasPOS={hasPermission('Facturas POS')}/> } />
        {hasPermission('Cierre Caja') && <Route path="/cierrecaja" element={<CierreCaja devices={devices}/>} />}

        <Route path="/conciliacion" element={<Conciliation devices={devices}/>} />
        <Route path="/estado_cajeros" element={<EstadoCajeros />} />
        <Route path="/resumendiarioboletas" element={<ResumenDiarioBoletas empresas={empresas}/>} />
        <Route path="/resumenmensualboletas" element={<ResumenMensualBoletas empresas={empresas}/>} />
       {hasPermission('Sincronizacion SAP') &&<Route path="/resumenSincScharfstein" element={<Resumensinc/>} />}
        {hasPermission('Usuarios POS') && <Route path="/usuariosposconfig" element={<PosUserConfig/>} />}
        {hasPermission('Facturacion') &&<Route path="/factura" element={<Factura empresas={empresas} />} />}
        {hasPermission('Skualo') && <Route path="/skualo" element={<Skualo devices={devices}/>} />}
        {hasPermission('Facturas POS') && <Route path="/receptorFactura" element={<ReceptorFactura empresas={empresas}/>} />}
         {hasPermission('Emision Masiva Boletas') && <Route path="/emisionmasiva" element={<EmisorMasivo empresas={empresas}/>} />}


        
      </Routes>
      </div>
      <footer>
      </footer>
    </main>
      </BrowserRouter>
    </div>
  );
}

export default App;